import styles from './Card.module.scss';
import { SllLesson } from '../../../types';
import { getMediaAbsolutePath } from '../../../services/File';


type Props = {
  lesson: SllLesson
  handleOpenLesson?: (lesson: SllLesson) => void
}


function Card(props: Props) {
  const { lesson, handleOpenLesson } = props

  return (
    <div className={styles.card} onClick={() => handleOpenLesson?.(lesson)} 
      style={{ backgroundImage: `url(${lesson.coverImage ? getMediaAbsolutePath(lesson.coverImage) : ''})` }}>
    </div>
  );
}

export default Card

